/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Vpn_DescriptionInputs */

const en_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how to add a device to your subscription, connect to a different server, troubleshoot an error code, cancel a premium subscription, and more.`)
};

const id_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari cara menambahkan perangkat ke langganan Anda, terhubung ke server yang berbeda, memecahkan kode kesalahan, membatalkan langganan premium, dan banyak lagi.`)
};

const ms_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari bagaimana untuk menambah peranti ke langganan anda, sambung ke pelayan yang berbeza, selesaikan ralat kod, batalkan langganan premium, dan banyak lagi.`)
};

const ca_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprèn com afegir un dispositiu a la teva subscripció, connectar-te a un servidor diferent, solucionar un codi d'error, cancel·lar una subscripció premium i molt més.`)
};

const cs_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zjistěte, jak přidat zařízení k vašemu předplatnému, připojit se k jinému serveru, řešit chybu, zrušit prémiové předplatné a další.`)
};

const da_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær, hvordan du føjer en enhed til dit abonnement, forbinder til en anden server, fejlretter en fejlkode, annullerer et premium-abonnement og mere.`)
};

const de_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie, wie Sie ein Gerät zu Ihrem Abonnement hinzufügen, eine Verbindung zu einem anderen Server herstellen, einen Fehlercode beheben, ein Premium-Abonnement kündigen und mehr.`)
};

const et_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Õppige, kuidas lisada seadmeid oma tellimusele, ühendada teise serveriga, tõrkeotsingut teostada, premiumi tellimust tühistada ja palju muud.`)
};

const es_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprende cómo agregar un dispositivo a tu suscripción, conectarte a un servidor diferente, solucionar un código de error, cancelar una suscripción premium y más.`)
};

const fr_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez comment ajouter un appareil à votre abonnement, vous connecter à un serveur différent, résoudre un code d’erreur, annuler un abonnement Premium, et plus encore.`)
};

const hr_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saznajte kako dodati uređaj svojoj pretplati, povezati se s drugim poslužiteljem, riješiti kod greške, otkazati premium pretplatu i više.`)
};

const it_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri come aggiungere un dispositivo al tuo abbonamento, connetterti a un server diverso, risolvere un errore, annullare un abbonamento premium e altro ancora.`)
};

const lv_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzziniet, kā pievienot ierīci savam abonementam, pieslēgties citam serverim, novērst kļūdu kodus, atcelt Premium abonementu un citus padomus.`)
};

const lt_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sužinokite, kaip pridėti įrenginį prie savo prenumeratos, prisijungti prie kito serverio, spręsti klaidos kodą, atšaukti premium prenumeratą ir daugiau.`)
};

const hu_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanulja meg, hogyan adhat hozzá egy eszközt az előfizetéséhez, csatlakoztathat más szerverhez, hibakódokat oldhat meg, lemondhatja a prémium előfizetést és még sok mást.`)
};

const nl_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer hoe je een apparaat toevoegt aan je abonnement, verbinding maakt met een andere server, een foutcode oplost, een premium abonnement annuleert en meer.`)
};

const nb_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finn ut hvordan du legger til en enhet i abonnementet ditt, kobler til en annen server, feilsøker en feilkode, sier opp et Premium-abonnement, og mye mer.`)
};

const pl_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się, jak dodać urządzenie do swojej subskrypcji, połączyć się z innym serwerem, znaleźć rozwiązanie dla kodu błędu, anulować subskrypcję premium i nie tylko.`)
};

const pt_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba como adicionar um dispositivo à sua assinatura, conectar a um servidor diferente, solucionar um código de erro, cancelar uma assinatura premium e muito mais.`)
};

const ro_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aflați cum să adăugați un dispozitiv la abonamentul dvs., să vă conectați la un server diferit, să remediați un cod de eroare, să anulați un abonament premium și multe altele.`)
};

const sk_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozviete sa, ako pridať zariadenie do svojho predplatného, pripojiť sa k inému serveru, riešiť chybové kódy, zrušiť prémiové predplatné a ďalšie.`)
};

const sl_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naučite se, kako dodati napravo k svoji naročnini, se povezati na drug strežnik, odpravljate napako, prekličete premium naročnino in še več.`)
};

const fi_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opi lisää siitä, miten lisäät laitteen tilaukseesi, yhdistät eri palvelimiin, korjaat virhekoodeja, perut premium-tilauksen ja paljon muuta.`)
};

const sv_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig hur du lägger till en enhet till ditt abonnemang, ansluter till en annan server, felsöker en felkod, avslutar en premiumprenumeration och mer.`)
};

const vi_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu cách thêm thiết bị vào gói đăng ký của bạn, kết nối với máy chủ khác, khắc phục sự cố mã lỗi, hủy đăng ký cao cấp, và nhiều hơn nữa.`)
};

const tr_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliğinize cihaz eklemeyi, farklı bir sunucuya bağlanmayı, hata kodunu gidermeyi, premium aboneliği iptal etmeyi ve daha fazlasını nasıl yapacağınızı öğrenin.`)
};

const el_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε πώς να προσθέσετε συσκευή στη συνδρομή σας, να συνδεθείτε σε άλλο διακομιστή, να αντιμετωπίσετε προβλήματα με έναν κωδικό σφάλματος, να ακυρώσετε μια premium συνδρομή και πολλά άλλα.`)
};

const bg_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научете как да добавите устройство към вашия абонамент, свържете се с различен сървър, отстраните код за грешка, анулирате премиум абонамент и други.`)
};

const ru_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте, как добавить устройство к вашей подписке, подключиться к другому серверу, устранить ошибки, отменить премиальную подписку и многое другое.`)
};

const sr_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сазнајте како да додате уређај на вашу претплату, повежете се на други сервер, решавате проблеме са кодом грешака, отказујете премиум претплату и још много тога.`)
};

const uk_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дізнайтеся, як додати пристрій до вашої підписки, підключитися до іншого сервера, усунути помилки, скасувати преміум-підписку та багато іншого.`)
};

const ka_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეიტყვეთ, როგორ დაამატოთ თქვენი გამოწერა მოწყობილობაზე, დაკავშირება სხვა სერვერზე, აღმოფხვრა შეცდომის კოდები, გაუქმება პრემიუმ გამოწერა და სხვა.`)
};

const hi_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानें कि अपने सब्सक्रिप्शन में डिवाइस को कैसे जोड़ें, एक अलग सर्वर से कनेक्ट करें, एक त्रुटि कोड का निवारण करें, एक प्रीमियम सदस्यता रद्द करें, और अधिक।`)
};

const th_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้วิธีเพิ่มอุปกรณ์ในแผนการสมัครของคุณ, เชื่อมต่อกับเซิร์ฟเวอร์อื่น, แก้ไขข้อผิดพลาด, ยกเลิกการสมัครพรีเมี่ยม และอื่น ๆ`)
};

const ko_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독에 기기를 추가하는 방법, 다른 서버에 연결하는 방법, 오류 코드를 해결하는 방법, 프리미엄 구독을 취소하는 방법 등을 알아보세요.`)
};

const zh_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解如何将设备添加到您的订阅中，连接到不同的服务器，排除错误代码，取消高级订阅等等。`)
};

const zh_tw_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瞭解如何將裝置新增至訂閱服務、連線至不同伺服器、排除錯誤代碼、取消高級版訂閱服務等操作。`)
};

const ja_brave_vpn_description = /** @type {(inputs: Brave_Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスをサブスクリプションに追加する方法、別のサーバーに接続する方法、エラーコードのトラブルシューティング、プレミアムサブスクリプションのキャンセル方法などを学びます。`)
};

/**
* | output |
* | --- |
* | "Learn how to add a device to your subscription, connect to a different server, troubleshoot an error code, cancel a premium subscription, and more." |
*
* @param {Brave_Vpn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_vpn_description = /** @type {((inputs?: Brave_Vpn_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Vpn_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_vpn_description(inputs)
	if (locale === "ms") return ms_brave_vpn_description(inputs)
	if (locale === "ca") return ca_brave_vpn_description(inputs)
	if (locale === "cs") return cs_brave_vpn_description(inputs)
	if (locale === "da") return da_brave_vpn_description(inputs)
	if (locale === "de") return de_brave_vpn_description(inputs)
	if (locale === "et") return et_brave_vpn_description(inputs)
	if (locale === "es") return es_brave_vpn_description(inputs)
	if (locale === "fr") return fr_brave_vpn_description(inputs)
	if (locale === "hr") return hr_brave_vpn_description(inputs)
	if (locale === "it") return it_brave_vpn_description(inputs)
	if (locale === "lv") return lv_brave_vpn_description(inputs)
	if (locale === "lt") return lt_brave_vpn_description(inputs)
	if (locale === "hu") return hu_brave_vpn_description(inputs)
	if (locale === "nl") return nl_brave_vpn_description(inputs)
	if (locale === "nb") return nb_brave_vpn_description(inputs)
	if (locale === "pl") return pl_brave_vpn_description(inputs)
	if (locale === "pt") return pt_brave_vpn_description(inputs)
	if (locale === "ro") return ro_brave_vpn_description(inputs)
	if (locale === "sk") return sk_brave_vpn_description(inputs)
	if (locale === "sl") return sl_brave_vpn_description(inputs)
	if (locale === "fi") return fi_brave_vpn_description(inputs)
	if (locale === "sv") return sv_brave_vpn_description(inputs)
	if (locale === "vi") return vi_brave_vpn_description(inputs)
	if (locale === "tr") return tr_brave_vpn_description(inputs)
	if (locale === "el") return el_brave_vpn_description(inputs)
	if (locale === "bg") return bg_brave_vpn_description(inputs)
	if (locale === "ru") return ru_brave_vpn_description(inputs)
	if (locale === "sr") return sr_brave_vpn_description(inputs)
	if (locale === "uk") return uk_brave_vpn_description(inputs)
	if (locale === "ka") return ka_brave_vpn_description(inputs)
	if (locale === "hi") return hi_brave_vpn_description(inputs)
	if (locale === "th") return th_brave_vpn_description(inputs)
	if (locale === "ko") return ko_brave_vpn_description(inputs)
	if (locale === "zh") return zh_brave_vpn_description(inputs)
	if (locale === "zh-tw") return zh_tw_brave_vpn_description(inputs)
	if (locale === "ja") return ja_brave_vpn_description(inputs)
	return en_brave_vpn_description(inputs)
});